import {
    EntitySetName,
    EntityTypeName, IBankStatementEntity
} from "@odata/GeneratedEntityTypes";
import { setDefByEntityType } from "../../getDefByEntityType";
import { getItemBreadCrumbsText, IDefinition, IGetDefinition } from "../../PageUtils";
import {
    getCoreDef,
    GROUP_TRANSACTIONS_ID
} from "../../banks/bankStatements/BankStatementsDef"
import LoanStatementsFormView from "@pages/loans/statements/LoanStatementsFormView";
import { IGetValueArgs } from "@components/smart/FieldInfo";
import { ISelectItem } from "@components/inputs/select/Select.types";
import { FormStorage } from "../../../views/formView/FormStorage";
import { createBankAccountsItems } from "@utils/BankUtils";
import { removeInactiveAccounts } from "@pages/banks/bankAccounts/BankAccounts.utils";
import { getTransactionsRender } from "@pages/banks/bankStatements/BankStatements.utils";
import { IGroupRenderFn } from "@components/smart/smartFormGroup/SmartFormGroup";
import i18next from "i18next";
import { Model } from "../../../model/Model";
import { DocumentTypeCode } from "@odata/GeneratedEnums";

export const getDefinitions: IGetDefinition = (): IDefinition => {
    const def = getCoreDef(DocumentTypeCode.LoanTransaction);

    def.form.id = `${EntityTypeName.LoanStatement}Form`;
    def.form.title = "Banks:LoanStatement.FormTitle";
    def.form.formControl = LoanStatementsFormView;
    def.form.translationFiles = getDefinitions.translationFiles;
    def.form.fieldDefinition.BankAccount.fieldSettings.itemsFactory = async (args: IGetValueArgs): Promise<ISelectItem[]> => {
        const accounts = (args.storage as FormStorage).context.getLoanAccounts();
        const items = createBankAccountsItems({ bankAccounts: accounts, addCurrency: true });
        const statement = (args.storage.data.entity as IBankStatementEntity);
        const accountId = statement.BankAccount?.Id;

        return removeInactiveAccounts(items, accountId);
    }

    def.form.getItemBreadCrumbText = (storage: Model) =>
        getItemBreadCrumbsText(storage, i18next.t("Banks:LoanStatement:NewFormTitle"), storage.data.entity?.NumberOurs);

    const transactionsGroup = def.form.groups.find(group => group.id === GROUP_TRANSACTIONS_ID);

    transactionsGroup.lineItems.columns = [{ id: "DateBankTransaction" }, { id: "SymbolVariable" }, { id: "TransactionAmount" }, { id: "ExchangeRatePerUnit" }];
    transactionsGroup.lineItems.render = (args: IGroupRenderFn) => {
        return getTransactionsRender(args, false);
    }

    transactionsGroup.title = i18next.t("Banks:LoanStatement.PairingTitle");

    def.table.filter = "";
    def.table.id = `${EntityTypeName.LoanStatement}Table`;
    def.table.title = i18next.t("Banks:LoanStatement.TableTitle");

    const definition: IDefinition = {
        entitySet: EntitySetName.LoanStatements,
        form: def.form,
        table: def.table
    };

    return definition;
};

getDefinitions.translationFiles = ["Loans", "Banks", "Common", "NumberRange", "Document", "BusinessPartner"];
setDefByEntityType(EntityTypeName.LoanStatement, getDefinitions);